import { Heading } from '@chakra-ui/react';
import { GetServerSideProps, NextPage } from 'next';

import { IPageError } from '@/interfaces/pageError';
import { queryMenuTabsForEvent } from '@/queries/menu-tabs';
import { generateStore } from '@/utils/generateStore';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

export interface IUrlQueryStringParams {
  eventId?: string;
}

interface IEventLibrayPageProps {
  error?: IPageError;
  eventId?: string;
}

const EventLibraryPage: NextPage<IEventLibrayPageProps> = () => {
  return <Heading>Menu items are missing!</Heading>;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { eventId } = urlQueryStringValidate<{ eventId: string }>(context.query, {
    eventId: StringParam,
  });
  const store = generateStore({ context });

  try {
    const { data: menuTabs } = await store.fetchResources(queryMenuTabsForEvent(eventId, { state: 'post_event' }));

    if (!menuTabs?.length) {
      return { notFound: true };
    }

    return {
      redirect: {
        destination: `/events/${eventId}/library/${menuTabs[0].id}`,
        permanent: false,
      },
    };
  } catch (err) {
    return { notFound: true };
  }
};

export default EventLibraryPage;
